import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {OrdersListSummary} from "@/model/OrdersListSummary";
import { FabricationOrderedProductsBreakdown } from "@/model/product/FabricationOrderedProductsBreakdown";
import { FabricationOrdersBreakdown } from "@/model/order/FabricationOrdersBreakdown";

export class FabricationOrdersEvent implements Serializable {
    
    storeId: string;
    updateDate: Date;
    isKeepAlive: boolean;
    
    summary: OrdersListSummary;
    orders: FabricationOrdersBreakdown;
    products: FabricationOrderedProductsBreakdown;

    fromJSON(rawObject: any): void {
        SerializationHelper.copyNonExcludedProperties(this, rawObject, ["summary", "orders", "products"]);
        if (rawObject['summary'] != null) {
            this.summary = SerializationHelper.toInstanceFromJsonObj(new OrdersListSummary(), rawObject['summary']);
        }
        if (rawObject['orders'] != null) {
            this.orders = SerializationHelper.toInstanceFromJsonObj(new FabricationOrdersBreakdown(), rawObject['orders']);
        }
        if (rawObject['products'] != null) {
            this.products = SerializationHelper.toInstanceFromJsonObj(new FabricationOrderedProductsBreakdown(), rawObject['products']);
        }
    }
}
